import React from "react";
import { Link } from "react-router";
import { RaisedButton, TextField, FlatButton } from "material-ui";
import replace from "string-replace-to-array";

import LoginInline from "./login-inline.jsx";
import FacebookLogin from "./facebook-login.jsx";
import EventivalLogin from "./eventival-login.jsx";
import SundanceLogin from "./sundance-login.jsx";
import AarpLogin from "./aarp-login.jsx";
import HorizontalSeparator from "./horizontal-separator.jsx";
import MailingListPreferenceField from "./mailing-list-preference-field.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonStore from "../../stores/PersonStore";
import PersonActions from "../../actions/PersonActions";
import PersonUtil from "../../utils/PersonUtil";

@connectToStores
class AccountCreation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "pending", // 'pending' | 'create' | 'login' | 'guest_checkout'
      name: "",
      username: "",
      password: "",
      confirmPassword: "",
      promoOptIn: false,
      hasNameError: false,
      hasUsernameError: false,
      hasPasswordError: false,
      lookingUpPerson: false,
      lookupError: false
    };

    this.lookup = this.lookup.bind(this);
    this.register = this.register.bind(this);
    this.facebookLogin = this.facebookLogin.bind(this);
    this.guestCheckout = this.guestCheckout.bind(this);
    this.cannesLogin = this.cannesLogin.bind(this);
    this.eventivalLogin = this.eventivalLogin.bind(this);
    this.sundanceLogin = this.sundanceLogin.bind(this);
    this.aarpLogin = this.aarpLogin.bind(this);
    this._handleNameChange = this._handleNameChange.bind(this);
    this._handleUsernameChange = this._handleUsernameChange.bind(this);
    this._handlePasswordChange = this._handlePasswordChange.bind(this);
    this._changeMode = this._changeMode.bind(this);
  }

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  static get contextTypes() {
    return {
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object
    };
  }

  componentWillMount() {
    PersonActions.clearErrors.defer();
  }

  lookup() {
    if (!/[^ @]*@[^ @]*/.test(this.state.username)) {
      this.setState({ lookupError: "A valid email address is required." });
      return;
    }

    this.setState({ lookingUpPerson: true });

    PersonUtil.lookup(this.state.username)
      .then(data => {
        if (data.exists && data.facebook_only) {
          throw new Error(
            'This account was created via Facebook. Please login using the "Continue with Facebook" button below.'
          );
        } else if (data.exists) {
          this._changeMode("login", { firstName: data.first_name });
        } else {
          this._changeMode("create");
        }
      })
      .catch(e => {
        let error;
        if (e.message.indexOf("(email-check)") !== -1) {
          const match = e.message.match(/\[(.*?)\]/);
          error = {
            type: "email-check",
            suggestion: match[1]
          };
        } else {
          error = e.message;
        }
        this.setState({ lookupError: error });
      })
      .finally(e => {
        this.setState({ lookingUpPerson: false });
      });
  }

  register() {

    console.log(this.context.tenant.global_config);

    console.log("do not email value");
    console.log(this.context.tenant.global_config && this.context.tenant.global_config.gdpr_opt_in && !this.state.promoOptIn);


    PersonActions.register({
      username: this.state.username,
      password: this.state.password,
      name: this.state.name,
      do_not_email:
        this.context.tenant.global_config &&
        this.context.tenant.global_config.gdpr_opt_in &&
        !this.state.promoOptIn
    });

  }

  facebookLogin(data) {
    PersonActions.registerWithFacebook(data.accessToken, {
      onAccountExists: this.props.redirectOnLogin,
      ...this.props.loginProps
    });
  }

  eventivalLogin(token) {
    PersonActions.loginWithEventival(token, {
      onAccountExists: this.props.redirectOnLogin,
      ...this.props.loginProps
    });
  }

  sundanceLogin(token) {
    PersonActions.loginWithSundance(token, {
      onAccountExists: this.props.redirectOnLogin,
      ...this.props.loginProps
    });
  }

  aarpLogin(token) {
    PersonActions.loginWithAARP(token, {
      onAccountExists: this.props.redirectOnLogin,
      ...this.props.loginProps
    });
  }

  cannesLogin() {
    PersonActions.loginWithCannes(this.state.username, this.state.password);
  }

  guestCheckout() {
    PersonActions.setGuestCheckout(this.state.username);
  }

  _handleNameChange(e) {
    this.state.name = e.target.value;
    this.state.hasNameError = !this.state.name;
    this.setState(this.state);
  }

  _handleUsernameChange(e) {
    this.state.username = e.target.value;
    this.state.hasUsernameError = !/[^ @]*@[^ @]*/.test(this.state.username);
    this.state.lookupError = false;
    this.setState(this.state);
  }

  _handlePasswordChange(key, e) {
    this.state[key] = e.target.value;
    this.state.hasPasswordError =
      this.state.confirmPassword &&
      this.state.password !== this.state.confirmPassword;
    this.setState(this.state);
  }

  _changeMode(mode, opts) {
    PersonActions.clearErrors();

    // Login - redirect to full login
    if (mode === "login" && this.props.redirectOnLogin) {
      if (this.props.redirectOnLogin(this.state.username, opts.firstName)) {
        return;
      }
    }

    this.setState({ mode: mode });
  }

  getStyles() {
    return {
      container: {
        textAlign: "left"
      },
      pending: {
        maxWidth: 280,
        margin: "0 auto"
      },
      intro: {
        textAlign: "center",
        fontSize: "11pt"
      },
      createDetails: {
        maxWidth: 380,
        margin: "0 auto"
      },
      facebookLogin: {
        textAlign: "center"
      },
      eventivalLogin: {
        textAlign: "center"
      },
      separator: {
        width: 280
      },
      actions: {
        marginTop: 10,
        textAlign: "center"
      },
      error: {
        color: "#FF4136",
        textAlign: "center",
        marginTop: 10
      },
      errorLink: {
        textDecoration: "underline",
        fontWeight: "bold",
        cursor: "pointer"
      },
      form: {
        minWidth: "70%",
        width: 200,
        margin: "0 auto"
      },
      field: {
        width: "100%"
      },
      termsNotice: {
        textAlign: "center",
        marginTop: 15,
        marginBottom: 20,
        color: "#808080"
      },
      termsLink: {
        color: "#808080"
      },
      a: {
        color: "#00e",
        textDecoration: "underline",
        cursor: "pointer"
      }
    };
  }

  render() {
    const styles = this.getStyles(),
      cannesMode = !!this.context.appSettings.cannes_mode,
      showPromoOptIn = !!this.context.tenant.global_config.gdpr_opt_in,
      showSundance =
        this.context.tenant.sundance_login &&
        (window.EVENTIVE_IS_EVERYWHERE ||
          !this.context.tenant.sundance_login_disable_native_site_sso),
      showAarp = this.context.tenant.use_aarp_registration_flow && window.EVENTIVE_IS_EVERYWHERE,
      showFacebook =
        !cannesMode &&
        !showSundance &&
        !this.context.appSettings.facebook_login_disabled,
      showEventival = this.context.appSettings.enable_eventival_login;

    return (
      <div style={Object.assign({}, styles.container, this.props.style)}>
        {showSundance ? (
          <div style={styles.pending}>
            <div style={styles.intro}>
              Please log in with your Sundance account to continue.
            </div>
            {this.props.loginErrorMessage ? (
              <div style={styles.error}>{this.props.loginErrorMessage}</div>
            ) : null}
            <div
              style={{ marginTop: 20, marginBottom: 20, textAlign: "center" }}
            >
              <SundanceLogin
                success={this.sundanceLogin}
                failure={PersonActions.loginFailed}
              />
            </div>
          </div>
        ) : showAarp ? (
          <div style={styles.pending}>
            <div style={styles.intro}>
              Please log in with your AARP account to continue.
            </div>
            {this.props.loginErrorMessage ? (
              <div style={styles.error}>{this.props.loginErrorMessage}</div>
            ) : null}
            <div
              style={{ marginTop: 20, marginBottom: 20, textAlign: "center" }}
            >
              <AarpLogin
                success={this.aarpLogin}
                failure={PersonActions.loginFailed}
              />
            </div>
          </div>
        ) :cannesMode ? (
          <div style={styles.pending}>
            <img
              src="https://storage.googleapis.com/eventive-co/cannes.svg"
              style={{
                width: 86,
                height: 60,
                display: "block",
                margin: "0 auto 5px"
              }}
            />
            <div style={styles.intro}>
              Please log in with your Cannes credentials to continue.
            </div>
            <div style={{ marginTop: 10 }}>
              <TextField
                hintText="Email address"
                value={this.state.username}
                onChange={e => this.setState({ username: e.target.value })}
                style={styles.field}
                autoComplete="username email"
                disabled={this.props.loginInProgress}
              />
            </div>
            <div>
              <TextField
                hintText="Password"
                disabled={this.props.loginInProgress}
                value={this.state.password}
                onChange={e => this.setState({ password: e.target.value })}
                style={styles.field}
                onKeyDown={e => {
                  if (e.keyCode === 13) this.cannesLogin();
                }}
                autoComplete="password"
                type={"password"}
              />
            </div>
            {this.props.loginErrorMessage ? (
              <div style={styles.error}>{this.props.loginErrorMessage}</div>
            ) : null}
            <div style={styles.termsNotice}>
              By logging in, you agree to the Eventive{" "}
              <a
                style={styles.termsLink}
                target="_blank"
                href="https://eventive.org/terms"
              >
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                style={styles.termsLink}
                target="_blank"
                href="https://eventive.org/privacy"
              >
                Privacy Policy
              </a>
              .
            </div>
            <div style={styles.actions}>
              <RaisedButton
                label={
                  this.props.loginInProgress
                    ? "Logging in..."
                    : "Log in with Cannes"
                }
                disabled={this.props.loginInProgress}
                primary={true}
                onClick={this.cannesLogin}
              />
            </div>
          </div>
        ) : this.state.mode === "pending" ? (
          <div style={styles.pending}>
            <div style={styles.intro}>
              Please enter your email to sign up or log in
              {showFacebook ? ", or continue with Facebook" : ""}.
            </div>
            <form>
              <TextField
                name="accountLookup"
                hintText="Email address"
                value={this.state.username || ""}
                onChange={this._handleUsernameChange}
                style={styles.field}
                disabled={this.state.lookingUpPerson}
                autoComplete="username email"
                //autoFocus // disabled since jumps on mobile
                type="email"
                onKeyDown={e => {
                  if (e.keyCode === 13) this.lookup();
                }}
                inputStyle={{ height: 36, marginTop: 6, paddingBottom: 6 }} // better location of autofill highlight
              />
              <input
                type="password"
                name="hiddenPassword"
                tabindex="-1"
                aria-hidden="true"
                spellcheck="false"
                style={{ display: "none" }}
              />
            </form>
            {this.state.lookupError || this.props.loginErrorMessage ? (
              <div style={styles.error}>
                {this.state.lookupError &&
                this.state.lookupError.type === "email-check" ? (
                  <span>
                    That email address doesn't seem quite right. Did you mean{" "}
                    <span
                      style={styles.errorLink}
                      onClick={() => {
                        this.setState(
                          {
                            username: this.state.lookupError.suggestion,
                            lookupError: null
                          },
                          () => {
                            this.lookup();
                          }
                        );
                      }}
                    >
                      {this.state.lookupError.suggestion}
                    </span>
                    ?
                  </span>
                ) : (
                  this.state.lookupError || this.props.loginErrorMessage
                )}
              </div>
            ) : null}
            <div style={styles.actions}>
              <RaisedButton
                label={
                  this.state.lookingUpPerson || this.props.loginInProgress
                    ? "Continuing..."
                    : "Continue"
                }
                disabled={
                  this.state.lookingUpPerson || this.props.loginInProgress
                }
                primary={true}
                onClick={this.lookup}
              />
            </div>
          </div>
        ) : this.state.mode === "guest_checkout" ? (
          <div style={styles.pending}>
            <div style={styles.intro}>
              <strong>Guest checkout:</strong> Please enter an email address
              where you'd like your tickets to be sent.{" "}
              <i>
                Note: If you continue as a guest, you will not have web access
                to your tickets.
              </i>
            </div>
            <form>
              <TextField
                name="guestCheckout"
                hintText="Email address"
                value={this.state.username || ""}
                onChange={this._handleUsernameChange}
                style={styles.field}
                //autoFocus // disabled since jumps on mobile
                type="email"
                onKeyDown={e => {
                  if (e.keyCode === 13) this.guestCheckout();
                }}
                inputStyle={{ height: 36, marginTop: 6, paddingBottom: 6 }} // better location of autofill highlight
              />
            </form>
            <div style={styles.actions}>
              <RaisedButton
                label={"Back"}
                style={{ marginRight: 7 }}
                onClick={() => this._changeMode("pending")}
              />
              <RaisedButton
                label={"Continue as guest"}
                primary={true}
                disabled={this.state.hasUsernameError}
                onClick={this.guestCheckout}
              />
            </div>
          </div>
        ) : this.state.mode === "create" ? (
          <form style={styles.form}>
            <div style={styles.intro}>
              Please provide the following information to create your account.
            </div>
            <div style={styles.createDetails}>
              <div style={{ position: "relative" }}>
                <TextField
                  name="accountEmail"
                  hintText="Email address"
                  value={this.state.username || ""}
                  onChange={this._handleUsernameChange}
                  errorText={
                    this.state.hasUsernameError
                      ? "A valid email address is required."
                      : null
                  }
                  style={styles.field}
                  autoComplete="username email"
                  disabled={true}
                  type="email"
                />
                <FlatButton
                  label="edit email"
                  labelStyle={{ padding: "0 5px" }}
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 12,
                    height: 24,
                    lineHeight: "24px"
                  }}
                  onClick={() => this._changeMode("pending")}
                />
              </div>
              <div>
                <TextField
                  name="accountName"
                  hintText="Full name"
                  value={this.state.name || ""}
                  onChange={this._handleNameChange}
                  errorText={
                    this.state.hasNameError
                      ? "A valid full name is required."
                      : null
                  }
                  style={styles.field}
                  disabled={this.props.loginInProgress}
                  autoComplete="name"
                  autoFocus
                />
              </div>
              <div>
                <TextField
                  name="accountPassword"
                  hintText="Password"
                  disabled={this.props.loginInProgress}
                  value={this.state.password || ""}
                  onChange={this._handlePasswordChange.bind(this, "password")}
                  style={styles.field}
                  autoComplete="new-password"
                  type="password"
                />
                <TextField
                  name="accountConfirmPassword"
                  hintText="Confirm password"
                  disabled={this.props.loginInProgress}
                  value={this.state.confirmPassword || ""}
                  onChange={this._handlePasswordChange.bind(
                    this,
                    "confirmPassword"
                  )}
                  errorText={
                    this.state.hasPasswordError
                      ? "The passwords do not match."
                      : null
                  }
                  style={styles.field}
                  onKeyDown={e => {
                    if (e.keyCode === 13) this.register();
                  }}
                  autoComplete="new-password"
                  type="password"
                />
              </div>
            </div>
            {this.props.loginErrorMessage ? (
              <div style={styles.error}>
                {replace(
                  this.props.loginErrorMessage,
                  "logging in",
                  <span
                    style={styles.errorLink}
                    onClick={() => this._changeMode("login")}
                  >
                    logging in
                  </span>
                )}
              </div>
            ) : null}
            {showPromoOptIn ? (
              <div
                style={{ width: "80%", maxWidth: 340, margin: "15px auto 0" }}
              >
                <MailingListPreferenceField
                  value={this.state.promoOptIn}
                  onChange={v => this.setState({ promoOptIn: v })}
                />
              </div>
            ) : null}
            <div style={styles.termsNotice}>
              By registering, you agree to the Eventive{" "}
              <a
                style={styles.termsLink}
                target="_blank"
                href="https://eventive.org/terms"
              >
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                style={styles.termsLink}
                target="_blank"
                href="https://eventive.org/privacy"
              >
                Privacy Policy
              </a>
              .
            </div>
            <div style={styles.actions}>
              <RaisedButton
                label={
                  this.props.loginInProgress ? "Registering..." : "Register"
                }
                disabled={this.props.loginInProgress}
                primary={true}
                onClick={this.register}
              />
            </div>
          </form>
        ) : (
          <LoginInline
            defaultUsername={this.state.username}
            style={{
              maxWidth: 280,
              minWidth: 280,
              width: 280,
              margin: "0 auto"
            }}
          />
        )}

        {this.state.mode === "pending" ? (
          <div>
            {showFacebook || showEventival ? (
              <HorizontalSeparator
                label="or"
                style={Object.assign({}, styles.separator, {
                  marginBottom: 25
                })}
              />
            ) : null}
            {showFacebook ? (
              <div style={styles.facebookLogin}>
                <FacebookLogin
                  label="Continue with Facebook"
                  success={this.facebookLogin}
                  failure={PersonActions.loginFailed}
                />
              </div>
            ) : null}
            {showEventival ? (
              <div
                style={Object.assign(
                  {},
                  styles.eventivalLogin,
                  showFacebook && { marginTop: 15 }
                )}
              >
                <EventivalLogin
                  label="Continue with Eventival"
                  success={this.eventivalLogin}
                  failure={PersonActions.loginFailed}
                />
              </div>
            ) : null}
            {this.context.appSettings.enable_guest_checkout &&
            this.props.allowGuestCheckout ? (
              <div>
                <HorizontalSeparator label="or" style={styles.separator} />
                <div
                  style={Object.assign({}, styles.actions, { marginTop: 20 })}
                >
                  <RaisedButton
                    label={"Checkout as guest"}
                    onClick={() => this._changeMode("guest_checkout")}
                  />
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}

export default AccountCreation;



// WEBPACK FOOTER //
// ./src/app/components/partials/account-creation.jsx